// data-testid registry — single source of truth, kebab-case role-based.
export const TID = {
    // Auth / login
    loginEmail: "login-email-input",
    loginPassword: "login-password-input",
    loginSubmit: "login-submit-button",
    loginMicrosoft: "login-microsoft-button",
    loginError: "login-error",
    loginModeLive: "login-mode-live",
    loginModeDemo: "login-mode-demo",
    demoPersona: (role) => `demo-persona-${role}`,
    demoResetLogin: "demo-reset-login-button",
    demoBanner: "demo-banner",
    demoSwitchTrigger: "demo-switch-trigger",
    demoSwitchMenu: "demo-switch-menu",
    demoSwitchPersona: (role) => `demo-switch-${role}`,
    demoResetData: "demo-reset-data-button",

    // App shell
    sidebar: "app-sidebar",
    sidebarToggle: "sidebar-toggle",
    viewSwitcher: "view-switcher",
    viewSwitcherOpen: "view-switcher-open",
    navItem: (id) => `nav-item-${id}`,
    topbarTitle: "topbar-title",
    topbarSearch: "topbar-search",
    topbarBell: "topbar-bell",
    userMenu: "user-menu-trigger",
    logout: "user-menu-logout",

    // Pages
    directorDashboard: "director-dashboard",
    kpi: (key) => `kpi-${key}`,
    clientsPage: "clients-page",
    clientRow: (id) => `client-row-${id}`,
    clientPortalDashboard: "client-portal-dashboard",
    leaderboardRow: (i) => `leaderboard-row-${i}`,
    auditLogPage: "audit-log-page",
    usersPage: "users-page",
    settingsPage: "settings-page",
};
